import client from 'data/client';
import { CDError } from 'utils/error';
import { Menu, ItemStatus } from 'model/menu';

export type VariablesSuspend = {
  brandId: string;
  itemId: string;
  pauseType: ItemStatus;
};

export type VariablesUnsuspend = {
  brandId: string;
  itemId: string;
};

export type ResponseStatus = {
  status: string;
};

export const suspendMenu = async ({
  brandId,
  itemId,
  pauseType,
}: VariablesSuspend) => {
  try {
    const { data } = await client.post<ResponseStatus>(
      `/menus/${brandId}/suspend`,
      { itemId, forever: pauseType === 'SUSPEND_INDEFINITE' },
      { headers: { 'content-type': 'application/json' } },
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};

export const unsuspendMenu = async ({
  brandId,
  itemId,
}: VariablesUnsuspend) => {
  try {
    const { data } = await client.post<ResponseStatus>(
      `/menus/${brandId}/unsuspend`,
      { itemId },
      { headers: { 'content-type': 'application/json' } },
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};

export type VariablesUpdate = {
  brandId: string;
  menu: Menu;
};

export const updateMenu = async ({ brandId, menu }: VariablesUpdate) => {
  try {
    const { data } = await client.post<ResponseStatus>(
      `/menus/${brandId}/update`,
      { ...menu },
      { headers: { 'content-type': 'application/json' } },
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};

export type VariablesExport = {
  brandId: string;
  usePrintNames: boolean;
};

export const exportDraftMenu = async ({
  brandId,
  usePrintNames,
}: VariablesExport) => {
  const params = new URLSearchParams();
  params.append('use_print', usePrintNames.toString());

  try {
    const { data } = await client.post<Blob>(
      `/menus/${brandId}/export/draft?${params.toString()}`,
      {},
      {
        responseType: 'blob',
      },
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};

export type VariablesImageUpload = {
  menuId: string;
  itemId: string;
  image: File;
};

export type ResponseImageUpload = {
  original: string;
  small: string;
  medium: string;
};

export const uploadImage = async ({
  menuId,
  itemId,
  image,
}: VariablesImageUpload) => {
  try {
    const { data } = await client.post<ResponseImageUpload>(
      `/menus/item_image/${menuId}/${itemId}`,
      image,
      { headers: { 'content-type': image.type } },
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};

export const uploadIDraftImage = async ({
  menuId,
  itemId,
  image,
}: VariablesImageUpload) => {
  try {
    const { data } = await client.post<ResponseImageUpload>(
      `/menus/${menuId}/items/${itemId}/image/draft`,
      image,
      { headers: { 'content-type': image.type } },
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};
